const declarationApprovalDescriptor = Object.freeze({
    type: 'declaration-approval',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(StepItem):step-9-label',
    fallbackTitle: 'Approve declaration',
    defaultDescriptionKey: null,
    fallbackDescription: 'Review and approve the declaration before sending the reply.',
    capabilities: {
        repeatable: false,
        supportedModes: ['single'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: ['request.declaration-approval'],
        writes: ['request.declaration-approval'],
    },
    effects: {
        publishes: ['request.declaration-approval.changed'],
        observes: [],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            showInstruction: { type: 'boolean', default: true },
        },
    },
    settingsUi: {
        showInstruction: { control: 'switch' },
    },
})

export { declarationApprovalDescriptor }
export default declarationApprovalDescriptor
